import { get_axios_instance, api_variables, errorHandler } from '@/apis/variables.js';
import Vue from 'vue';
var axios_instance = get_axios_instance(api_variables.SERVICE_SALARY_BANDS);
var axios_instance2 = get_axios_instance(api_variables.SERVICE_INCREMENT_SETTINGS)
const _pk_name = "id";

const state = {
    data: {},
    isFetching: false,
    isSaving: false,
    isDeleting: false,
    editMode: false,
    record: {}
};

const getters = {
    editMode: (state) => {
        return state.editMode;
    },
    record: (state) => {
        return state.record;
    }
}

const mutations = {
    set: (state, [payload, id]) => {
        if (id) {
            Vue.set(state.data, id, payload);
        }
    },

    addEntity: (state, [payload, id]) => {
      if (!state.data[id]) {
        state.data[id] = [payload];
      } else {
        state.data[id].push(payload);
      }
    },

    updateEntityById: (state, [payload, id]) => {
        for (let i = 0; i < state.data[id].length; i++) {
            if (state.data[id][i][_pk_name] === payload.id) {
                state.data[id].splice(i, 1, payload);
            }
        }
    },

    removeEntityById: (state, [payload, id]) => {
        for (let i = 0; i < state.data[id].length; i++) {
            if (state.data[id][i][_pk_name] == payload) {
                state.data[id].splice(i, 1);
            }
        }
    },

    setFetching: (state, payload) => {
        state.isFetching = payload;
    },

    setSaving: (state, payload) => {
        state.isSaving = payload;
    },

    setDeleting: (state, payload) => {
        state.isDeleting = payload;
    },
    setEditMode: (state, payload) => {
        state.editMode = payload.editMode;
        state.record = payload.record;
    }
}

const actions = {
    async fetchAll({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance.get(`/`, {
                params: {
                    le_id: payload
                }
            });
            commit("setFetching", false);
            if (res.status == 200) {
                commit("set", [res.data.payload.data, payload]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async create({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.post('/', { data: payload });
            commit("setSaving", false);
            if (res.status == 200) {
                commit("addEntity", [res.data.payload, payload.le_id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async update({ commit }, [payload, id]) {
        try {
            commit("setSaving", true);
            let res = await axios_instance.put(`/${id}`, payload);
            commit("setSaving", false);
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async createIncrement({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance2.post('/', payload);
            commit("setSaving", false);
            if (res.status == 200) {
                commit("addEntity", res.payload.data);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async updateIncrement({ commit }, payload) {
        try {
            commit("setSaving", true);
            let res = await axios_instance2.put(`/`, payload);
            commit("setSaving", false);
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },

    async getIncremntData({ commit }, payload) {
        try {
            commit("setFetching", true);
            let res = await axios_instance2.get(`/`, {
                params: {
                    le_id: payload
                }
            });
            commit("setFetching", false);
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async delete({ commit }, [payload, id]) {
        try {
            commit("setDeleting", true);
            let res = await axios_instance.delete(`/${payload.id}`);
            commit("setDeleting", false);
            if (res.status == 200) {
                commit("removeEntityById", [payload.id, id]);
            }
            return res;
        } catch (error) {
            throw errorHandler(error.response);
        }
    },
    async changeEditMode({ commit }, payload) {
        try {
            commit("setEditMode", payload);
        } catch (error) {
            throw errorHandler(error.response);
        }
    }
}

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
